module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.colors[_vm.currentColor],
    attrs: {
      "id": "app"
    },
    on: {
      "wheel": _vm.scroll
    }
  }, [_c('in-view', {
    ref: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('div', {
    attrs: {
      "id": "passwd-modal-cnt"
    },
    on: {
      "click": function($event) {
        return _vm.hidePassword($event);
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "passwd-modal"
    }
  }, [_c('div', {
    attrs: {
      "id": "passwd-close"
    }
  }, [_c('a', {
    attrs: {
      "href": "#",
      "id": "passwd-x"
    },
    on: {
      "click": function($event) {
        return _vm.hidePassword($event);
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "passwd-text"
    }
  }, [_vm._v("ENTER PASSWORD")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('input', {
    attrs: {
      "id": "passwd",
      "type": "password"
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && $event.keyCode !== 13) { return null; }
        return _vm.checkPassword($event);
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#",
      "id": "passwd-button"
    },
    on: {
      "click": function($event) {
        return _vm.checkPassword($event);
      }
    }
  }, [_vm._v("ENTER")])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar center-block text-center",
    class: {
      scrollup: _vm.isScrollUp
    }
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('div', {
    class: _vm.startHome ? 'logo-bar large' : 'logo-bar'
  }), _vm._v(" "), _c('div', {
    class: _vm.startHome ? 'start logo-background' : 'logo-background'
  }), _vm._v(" "), _c('div', {
    class: _vm.startHome ? 'start text' : 'text'
  }, [_vm._v("CREATIVE DIRECTION, UX DESIGN")])]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center"
  }, [_c('a', {
    staticClass: "btn btn-op",
    class: _vm.slides[0].active ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeSlide(0, true)
      }
    }
  }, [_vm._v("UX")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-op",
    class: _vm.slides[1].active ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeSlide(1, true)
      }
    }
  }, [_vm._v("Creative\n          Direction")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-op",
    class: _vm.slides[2].active ? 'active' : '',
    on: {
      "click": function($event) {
        return _vm.changeSlide(2, true)
      }
    }
  }, [_vm._v("Wireframes")])])]), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center case-studies",
    class: {
      scrollup: _vm.isScrollUp
    }
  }, [_c('a', {
    staticClass: "btn btn-op",
    attrs: {
      "href": "#",
      "target": "_blank"
    },
    on: {
      "click": function($event) {
        return _vm.showPassword($event);
      }
    }
  }, [_vm._v("VIEW CASE STUDIES")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.smallNav),
      expression: "!smallNav"
    }],
    staticClass: "header"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slides[0].active),
      expression: "slides[0].active"
    }],
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('slide-show', {
    attrs: {
      "init": _vm.slides[0].activeSlide,
      "small": _vm.smallNav,
      "status": _vm.slides[0].active
    },
    on: {
      "sc": _vm.slideChanged
    }
  }, [_c('slide', {
    attrs: {
      "slot": "item",
      "init": true
    },
    slot: "item"
  }, [_c('h1', [_vm._v("01 – Ficksr – web")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating\n              closely with Development team on the full range of materials for the application's website, CMS, mobile\n              app.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX1.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX2.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX3.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX4.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX5.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX6.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX7.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX8.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX9.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX10.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX11.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX12.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("02 – Ficksr – app")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating\n              closely with Development team on the full range of materials for the application's website, CMS, mobile\n              app.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX13.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX14.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX15.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX16.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX17.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX18.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX19.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX20.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX21.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX22.jpg"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("03 – ShipChat – web")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Led a team of UX and visual designers, turning a logistics, shipping and\n              transport service into a conversational chatbot system targeting millennials. Conducted competitive\n              research, user surveys and interviews. Advocated UX patterns and a visual design approach that\n              emphatically differentiates the product.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX23.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX25.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX26.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX27.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX28.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX29.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX30.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("04 – ShipChat – app")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Led a team of UX and visual designers, turning a logistics, shipping and transport service into a\n              chatbot system targeting millennials. Conducted competitive research, user surveys and interviews.\n              Advocated UX patterns and a visual design approach that emphatically differentiates the product.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX30.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/Ux30a.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX30b.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX30c.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX31.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX32.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX34.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("05 – LaughOn")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Led the design team in turning a crowdsourced comedy platform into a live, interactive experience.\n              Conducted research and usability tests and implemented frequent design iterations in an Agile\n              environment.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX35.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX36.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX37.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX38.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX39.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX40.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX41.png"),
      "alt": "Ficksr"
    }
  })])])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("06 – VirtualDossier")]), _vm._v(" "), _c('h2', [_vm._v("Interaction Design, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Worked with Design team on reporting & analytics tools and workflows. Worked with Analytics team to\n              understand & analyze large amounts of data, and to design insight-generating tools and visualizations.\n              Outlined a modular approach to designing and testing data visualization tools and user interactions.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX42.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX43.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX44.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX45.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX46.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX47.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("07 – LawTrades, Tomo")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI")]), _vm._v(" "), _c('p', [_vm._v("\n              Led creative team in UX research and planning, detailed wireframing and\n              prototyping. Lead the visual design of user interfaces, information architecture and\n              interaction flows to create user-centric design solutions.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX48.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/UX49.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX50.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/UX51.png"),
      "alt": "Ficksr"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slides[1].active),
      expression: "slides[1].active"
    }],
    attrs: {
      "id": "wireframe"
    }
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('slide-show', {
    attrs: {
      "init": _vm.slides[1].activeSlide,
      "small": _vm.smallNav,
      "status": _vm.slides[1].active
    },
    on: {
      "sc": _vm.slideChanged
    }
  }, [_c('slide', {
    attrs: {
      "slot": "item",
      "init": true
    },
    slot: "item"
  }, [_c('h1', [_vm._v("01 – Ficksr – web")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating\n              closely with Development team on the full range of materials for the application's website, CMS, mobile\n              app.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection1.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection2.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection3.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("02 – Ficksr – app")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Work includes UX/UI, Conducting research, Creative Direction, leading Design team and collaborating\n              closely with Development team on the full range of materials for the application's website, CMS, mobile\n              app.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection4.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection5.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection6.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection7.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection8.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection9.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("03 – ShipChat – web")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Led a team of UX and visual designers, turning a logistics, shipping and transport service into a\n              conversational chatbot system targeting millennials. Conducted competitive research, user surveys and\n              interviews. Advocated UX patterns and a visual design approach that emphatically differentiates the\n              product.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection10.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection11.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection12.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection13.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection14.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection15.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection16.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection17.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection18.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("04 – ShipChat – app")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI, CD")]), _vm._v(" "), _c('p', [_vm._v("\n              Led a team of UX and visual designers, turning a logistics, shipping and transport service into a custom\n              chatbot system targeting millennials. Conducted competitive research, user surveys and interviews.\n              Advocated UX patterns and a visual design approach that emphatically differentiates the product.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection19.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection20.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection21.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection22.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection23.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection24.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection25.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection26.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image-simple-space"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection27.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image-simple-space"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection28.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("05 – Further samples/Iterations")]), _vm._v(" "), _c('h2', [_vm._v("UX, UI")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection29.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection30.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/CreativeDirection31.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection32.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection33.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection34.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection35.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection36.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection37.jpg"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "src": require("./assets/CreativeDirection38.jpg"),
      "alt": "Ficksr"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slides[2].active),
      expression: "slides[2].active"
    }],
    attrs: {
      "id": "mobile"
    }
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('slide-show', {
    attrs: {
      "init": _vm.slides[2].activeSlide,
      "small": _vm.smallNav,
      "status": _vm.slides[2].active
    },
    on: {
      "sc": _vm.slideChanged
    }
  }, [_c('slide', {
    attrs: {
      "slot": "item",
      "init": true
    },
    slot: "item"
  }, [_c('h1', [_vm._v("01 – 1800Flowers")]), _vm._v(" "), _c('h2', [_vm._v("UX")]), _vm._v(" "), _c('p', [_vm._v("Redesign of email settings and account preferences for the e-commerce platform and its partner\n              companies. Fast-paced wireframe iterations within Agile environment. full-image\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes1.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes2.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes3.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes4.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes5.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes6.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes7.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes8.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("02 – DiMassimo Goldstein")]), _vm._v(" "), _c('h2', [_vm._v("UX")]), _vm._v(" "), _c('p', [_vm._v("\n              Translated user interviews and usability survey results into an intuitive user-centered\n              experience in line with marketing goals. Participation in discovery sessions with stakeholders to define features and interaction and produce UX deliverables.\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes9.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes11.png"),
      "alt": "Ficksr"
    }
  })])]), _vm._v(" "), _c('slide', {
    attrs: {
      "slot": "item"
    },
    slot: "item"
  }, [_c('h1', [_vm._v("03 – Further samples/Iterations")]), _vm._v(" "), _c('h2', [_vm._v("UX")]), _vm._v(" "), _c('p', [_vm._v("UX, Wireframing")]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes12.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes13.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes14.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes15.png"),
      "alt": "Ficksr"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center image"
  }, [_c('img', {
    staticClass: "img-responsive center-block full-image",
    attrs: {
      "src": require("./assets/Wireframes16.png"),
      "alt": "Ficksr"
    }
  })])])], 1)], 1)]), _vm._v(" "), _c('in-view', {
    ref: "bottom"
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 content"
  }, [_c('div', {
    staticClass: "center-block text-center"
  }, [_c('h2', {
    staticClass: "center-block text-center"
  }, [_vm._v("OCTAVIAN"), _c('br'), _vm._v("PAVELESCU")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "center-block text-center"
  }, [_c('h1', {
    staticClass: "center-block text-center"
  }, [_vm._v("Portfolio")])]), _vm._v(" "), _c('div', {
    staticClass: "center-block descriptionTitle"
  }, [_c('h4', {
    staticClass: "center-block"
  }, [_vm._v("Creative Direction, User Experience, Interaction Design")]), _vm._v(" "), _c('h6', {
    staticClass: "center-block"
  }, [_vm._v("UX, UI, CD")])]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n          Creative Director specializing in User Experience with an academic background in Media/Design and 8\n          years of\n          interactive Design experience.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5244ad94!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 139
// module chunks = 0